import '../../assets/css/dashboard.css';
import 'bootstrap-daterangepicker/daterangepicker.css';

import { Component } from 'react';
import DataTable from 'react-data-table-component';
import DatePicker from "react-datepicker";
import DateRangePickerV2 from '../../lib/custom/DateRangePickerV2/DateRangePickerV2';
import { formatNumber, isDesktop, isMobile, setClassNameCondition, showNotification, formatDate, formatNumberDecimal } from "../../lib/helper";
import { connect } from "react-redux";
import { fetchingUser, fetchingUserSuccess, updateMemberAction } from "../../redux/actions";
import { withRouter } from "react-router-dom";
import api from "../../lib/api";
import constants from "../../lib/constants";
import Highcharts, { chart } from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import DateRangePicker from "../../lib/custom/DateRangePicker";
import moment from "moment";
import i18n from '../../i18n';
import { withTranslation } from 'react-i18next';
import { translations } from '../../locales/i18nData';
const highChartOptions = {
	chart: {
		type: "pie",
		height: 200,
		width: 200,
		backgroundColor: 'transparent',
	},
	title: {
		text: '<p className="trade-stat label text-white">Lượt giao dịch</p><p className="trade-stat value">' + 0 + "</p>",
		align: "center",
		verticalAlign: "middle",
		style: {
			color: "#fff"
		},
		useHTML: !0,
		floating: !0,
		y: 60,
		x: 0
	},
	plotOptions: {
		pie: {
			innerSize: "80%",
			dataLabels: {
				enabled: !1
			},
			borderWidth: 0
		},
		series: {
			dataLabels: [{
				enabled: !0
			}]
		}
	},
	tooltip: {
		formatter: function () {
			return `${this.point.name} <b>${this.point.y}</b> vòng`;
		}
	},
	series: {
		type: "pie",
		data: [],
		dataLabels: [{
			enabled: false
		}]
	},
	credits: {
		enabled: !1
	},
};

class Dashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			is_show_withdrawal_box: false,
			page: 1,
			per_page: 10,
			page_number: [],
			transaction_list: [],
			transaction_total: 0,
			sort_selector: 'created_at',
			sort_direction: 'desc',
			filter_from: moment(),
			filter_to: moment(),
			total_all: 0,
			percent_up: -1,
			fund: 0,
			total_win: 0,
			total_lose: 0,
			total_draw: 0,
			revenue: 0,
			profit: 0,
			options: highChartOptions,

			hide: '*****',
			transaction_count: 0,
		};
		this.columns = [
			{
				name: 'Mã giao dịch',
				selector: 'code',
				sortable: false,
			},
			{
				name: 'Thời gian bắt đầu',
				selector: 'created_at',
				sortable: true,
			},
			{
				name: 'Đã chọn',
				selector: 'bet_condition',
				sortable: true,
				format: (row) => (<span className={'bet_condition ' + row.bet_condition}>{row.bet_condition === 'up' ? 'Mua' : 'Bán'}</span>)
			},
			{
				name: 'Giá mở ($)',
				selector: 'open_price',
				sortable: true,
				allowOverflow: true,
				right: true,
				format: (row, index) => (row.open_price ? <span>{formatNumber(row.open_price)}</span> : '-'),
			},
			{
				name: 'Giá đóng ($)',
				selector: 'close_price',
				sortable: true,
				allowOverflow: true,
				right: true,
				format: (row, index) => (row.close_price ? <span>{formatNumber(row.close_price)}</span> : '-'),
			},
			{
				name: 'Giá đặt ($)',
				selector: 'bet_value',
				sortable: true,
				right: true,
				format: (row, index) => (<span>{formatNumber(row.bet_value)}</span>),
			},
			{
				name: 'Lợi nhuận ($)',
				selector: 'value',
				sortable: true,
				right: true,
				format: (row, index) => (<span style={{ color: row.value < 0 ? 'red' : 'green' }}>{formatNumber(row.value)}</span>),
			},
		];
	}

	componentDidMount() {
		api.getDashboard()
			.then(({ data, success, message }) => {
				this.setState({ noData: data.total_all === 0 });
				let pieData = [
					{
						y: data.total_win,
						color: 'rgb(45, 85, 253)',
						name: 'Thắng'
					},
					{
						y: data.total_draw,
						color: 'rgb(123, 115, 142)',
						name: 'Hòa'
					},
					{
						y: data.total_lose,
						color: 'rgb(255, 42, 85)',
						name: 'Thua'
					}
				];
				let options = {
					...highChartOptions,

					series: {
						...highChartOptions.series,
						data: pieData
					},
					title: {
						...highChartOptions.title,
						text: `<p class="trade-stat label text-white">${i18n.t("TradeTurns")}</p><p class="trade-stat value text-center">${data.total_all}</p>`
					}
				};
				success && this.setState({ ...data, options });
			});
		this.loadTransaction();
	}
	toggleBalanceShow = () => (e) => {
		e.preventDefault();
		let { is_show_balance } = this.props.memberReducer;
		this.props.updateMemberAction({ is_show_balance: !is_show_balance });
	}
	loadTransaction = () => {
		let { page, per_page, sort_selector, sort_direction, filter_from, filter_to } = this.state;
		api.getTransaction({
			limit: per_page, page, transaction_type: constants.TRANSACTION_TYPE.BET, sort_selector, sort_direction,
			filter_from: filter_from.format('YYYY-MM-DD'),
			filter_to: filter_to.format('YYYY-MM-DD'),
			point_type: 'real'
		}).then(({ data, success }) => {
			if (success) {
				this.setState({ transaction_list: data.data, transaction_total: data.total });
			}
		})
	}

	handlePageChange = (type) => (e) => {
		e.preventDefault();
		switch (type) {
			case 'prev':
				this.setState({ page: this.state.page - 1 }, this.loadTransaction)
				break;
			case 'next':
				this.setState({ page: this.state.page + 1 }, this.loadTransaction)
				break;
		}
	}
	setPagination = () => {
		let { transaction_total, per_page } = this.state;
		const pageNumbers = [];
		for (let i = 1; i <= Math.ceil(transaction_total / per_page); i++) {
			pageNumbers.push(i);
		}
		return pageNumbers;
	}
	handlePerRowsChange = (per_page) => {
		this.setState({ per_page }, this.loadTransaction)
	}

	onSort = (column, sortDirection) => {
		this.setState({ sort_selector: column.selector, sort_direction: sortDirection }, this.loadTransaction)
	}

	handleChangeDateRange = (e) => {
		this.setState({ filter_from: e.target.value }, this.loadTransaction)
	}
	handleDateChange = ({ startDate, endDate }) => {
		this.setState({
			filter_from: moment(startDate),
			filter_to: moment(endDate)
		},
		)
	};
	getPercentWin = () => {
		let { total_all, total_win, hide } = this.state;
		let { is_censored } = this.props.memberReducer;
		if (is_censored) return hide;
		return `${total_all > 0 ? formatNumberDecimal(Math.ceil(total_win * 100 / total_all)) : 0}%`
	}
	render() {
		let { t } = this.props;
		let { total_all, noData, total_win, revenue, profit, fund, options, percent_up, transaction_total, transaction_list
			, filter_from, filter_to, transaction_histories, hide,
			transaction_count, page } = this.state;
		let page_number = this.setPagination();
		let { is_show_balance, is_censored } = this.props.memberReducer;
		return (
			<div data-v-b0e45e8c="" id="mainContent">
				<div data-v-b0e45e8c="" className="boxContent">
					<div data-v-7a0c51c4="" data-v-b0e45e8c="" className="tradeHistory">
						<div data-v-7a0c51c4="" className="container">
							<div data-v-7a0c51c4=""
								className="headerContent justify-content-between align-items-center mb-4">
								<div data-v-7a0c51c4="" className="d-flex justify-content-between"><h1
									data-v-7a0c51c4=""
									className="font-30 color-white font-weight-700 text-capitalize position-relative">
									{t('BOData')}
								</h1>
									<a data-v-7a0c51c4="" onClick={this.toggleBalanceShow()}
										className="d-inline-flex align-items-center color-white pointer">
										<span
											data-v-7a0c51c4="" className="btn-eyes" />
										<span
											data-v-7a0c51c4="">{t('HideBalance')}</span>
									</a>
								</div>
								{/* <div data-v-7a0c51c4="" className="row">
									<div data-v-7a0c51c4="" className="col-md-12 col-lg-6 mb-3">
										<div data-v-7a0c51c4="" className="bostats">
											<div data-v-b6d115ca="" data-v-7a0c51c4="" className="wrap-chart">
												<div data-v-b6d115ca="" className="nodata">
													<div data-v-b6d115ca="" className="wrap-chart">
														<div data-v-b6d115ca="" className="chart-instance">
															<div data-v-b6d115ca="" className="row">
																<div data-v-b6d115ca="" className="col-md-6 mb-3">
																	<div data-v-b6d115ca="" className="d-flex justify-content-center align-items-center">
																		<HighchartsReact
																			ref={ref => this.refChart = ref}
																			highcharts={Highcharts}
																			options={options}
																		/>
																	</div>
																</div>
																<div data-v-b6d115ca=""
																	className="col-md-6 py-md-5 flex align-middle justify-content-around">
																	<div data-v-b6d115ca="" className="row wrap">
																		<div data-v-b6d115ca=""
																			className="label colorWhite mb-3 col-md-12">
																			<span data-v-b6d115ca="" className="round"
																				style={{ backgroundColor: 'rgb(45, 85, 253)' }} />
																			<span data-v-b6d115ca="">Tổng vòng thắng</span>
																		</div>
																		<div data-v-b6d115ca=""
																			className="label colorWhite mb-3 col-md-12">
																			<span data-v-b6d115ca="" className="round"
																				style={{ backgroundColor: 'rgb(123, 115, 142)' }} />
																			<span
																				data-v-b6d115ca="">Tổng vòng hòa</span>
																		</div>
																		<div data-v-b6d115ca=""
																			className="label colorWhite mb-3 col-md-12">
																			<span data-v-b6d115ca="" className="round"
																				style={{ backgroundColor: 'rgb(255, 42, 85)' }} />
																			<span
																				data-v-b6d115ca="">Tổng vòng thua</span>
																		</div>
																	</div>
																</div>
																<div data-v-b6d115ca=""
																	className="col-md-6 lg-py-3 borderRightColor mb-sm-3">
																	<p data-v-b6d115ca="" className="colorWhite67 text-center m-0 mb-2 name">Tỷ lệ thắng</p>
																	<p data-v-b6d115ca="" className="colorWhite text-center value">{total_all > 0 ? Math.ceil(total_win * 100 / total_all) : 0}%</p>
																</div>
																<div data-v-b6d115ca="" className="col-md-6"><p
																	data-v-b6d115ca=""
																	className="colorWhite67 text-center m-0 mb-2 name">Tổng giao dịch</p>
																	<p data-v-b6d115ca="" className="colorWhite text-center value">${formatNumber(fund)}</p>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div data-v-7a0c51c4="" className="col-md-12 col-lg-6 mb-3">
										<div data-v-7a0c51c4="" className="row">
											<div data-v-7a0c51c4="" className="col-md-12 col-lg-6 mb-3">
												<div data-v-7a0c51c4=""
													className="userStat profits py-5 d-flex align-middle justify-content-around">
													<div data-v-7a0c51c4="" className="wrap">
														<div data-v-7a0c51c4="" className="icon text-center">
															<svg data-v-7a0c51c4="" xmlns="http://www.w3.org/2000/svg"
																width="43.525" height="40.623"
																viewBox="0 0 43.525 40.623">
																<g data-v-7a0c51c4="" id="bar-graph-profit"
																	transform="translate(0 -1)">
																	<path data-v-7a0c51c4="" id="Path_29851"
																		data-name="Path 29851"
																		d="M42.074,38.722H40.623V2.451A1.451,1.451,0,0,0,39.173,1h-5.8a1.451,1.451,0,0,0-1.451,1.451V38.722h-5.8V14.058a1.451,1.451,0,0,0-1.451-1.451h-5.8a1.451,1.451,0,0,0-1.451,1.451V38.722h-5.8V25.664a1.451,1.451,0,0,0-1.451-1.451h-5.8A1.451,1.451,0,0,0,2.9,25.664V38.722H1.451a1.451,1.451,0,0,0,0,2.9H42.074a1.451,1.451,0,1,0,0-2.9Z"
																		fill="#b9c7ff" />
																</g>
															</svg>
														</div>
														<div data-v-7a0c51c4="" className="info">
															<p data-v-7a0c51c4="" className="name m-0 mb-2">Lợi nhuận ròng</p>
															<p data-v-7a0c51c4="" className="value colorWhite m-0 d-flex">
																<span data-v-7a0c51c4="" className="font-arial">$</span>
																<span data-v-7a0c51c4="">{formatNumber(profit)}</span>
															</p>
														</div>
													</div>
												</div>
											</div>
											<div data-v-7a0c51c4="" className="col-md-12 col-lg-6 mb-3">
												<div data-v-7a0c51c4=""
													className="userStat revenue py-5 d-flex align-middle justify-content-around">
													<div data-v-7a0c51c4="" className="wrap">
														<div data-v-7a0c51c4="" className="icon text-center">
															<svg data-v-7a0c51c4="" xmlns="http://www.w3.org/2000/svg"
																width="49.009" height="55.129"
																viewBox="0 0 49.009 55.129">
																<g data-v-7a0c51c4="" id="savings"
																	transform="translate(-4.441 -1)">
																	<path data-v-7a0c51c4="" id="Path_29852"
																		data-name="Path 29852"
																		d="M30.559,1A11.559,11.559,0,1,0,42.119,12.559,11.559,11.559,0,0,0,30.559,1Zm5.075,12.188-4.446,4.446a.889.889,0,0,1-1.257,0l-4.446-4.446a.889.889,0,0,1,0-1.257l4.446-4.446a.889.889,0,0,1,1.257,0l4.446,4.446A.889.889,0,0,1,35.634,13.188Z"
																		transform="translate(-1.613)"
																		fill="#bbe8e0" />
																	<path data-v-7a0c51c4="" id="Path_29853"
																		data-name="Path 29853"
																		d="M19.367,49l1.459,11.67a.889.889,0,0,0,.882.779H39.492a.889.889,0,0,0,.882-.779L41.833,49Z"
																		transform="translate(-1.654 -5.32)"
																		fill="#bbe8e0" />
																	<path data-v-7a0c51c4="" id="Path_29854"
																		data-name="Path 29854"
																		d="M53.149,32.773a15.086,15.086,0,0,0-23.314,4.239V28.95c-.3.019-.589.044-.889.044s-.594-.026-.889-.044v8.062A15.086,15.086,0,0,0,4.742,32.773a.889.889,0,0,0,0,1.334,15.056,15.056,0,0,0,19.339.513,13.3,13.3,0,0,1,3.93,8.6H18.276a.889.889,0,0,0-.882,1l.1.779H40.4l.1-.779a.889.889,0,0,0-.882-1H29.88a13.3,13.3,0,0,1,3.93-8.6,15.056,15.056,0,0,0,19.339-.513.889.889,0,0,0,0-1.334Z"
																		transform="translate(0 -3.098)"
																		fill="#bbe8e0" />
																</g>
															</svg>
														</div>
														<div data-v-7a0c51c4="" className="info">
															<p data-v-7a0c51c4="" className="name m-0 mb-2"> Tổng doanh thu</p>
															<p data-v-7a0c51c4="" className="value colorWhite m-0 d-flex">
																<span data-v-7a0c51c4="" className="font-arial">$</span>
																<span data-v-7a0c51c4="">{formatNumber(revenue)}</span>
															</p>
														</div>
													</div>
												</div>
											</div>
											<div data-v-7a0c51c4="" className="col-md-12">
												<div data-v-417299ea="" data-v-7a0c51c4="" className="wrap-chart">
													<div data-v-417299ea="" className="chart-instance py-3">
														<div data-v-417299ea="" className="row">
															<div data-v-417299ea="" className="col-md-12 mb-2"><h4
																data-v-417299ea=""
																className="text-center font-20 color-white-50 mb-3">Tóm tắt giao dịch</h4>
																<div data-v-417299ea="" className={setClassNameCondition(percent_up > -1, '', 'nodata', 'customChartPercent')}>
																	<div data-v-417299ea="" className="percentUp" style={{ width: percent_up > -1 ? `${percent_up}%` : '0%' }} />
																</div>
															</div>
															<div data-v-417299ea="" className="col-sm-6 col-md-6 pl-4">
																<p data-v-417299ea=""><span data-v-417299ea=""
																	className="name colorWhite">Bán</span>
																	<span data-v-417299ea=""
																		className="value colorRed">{(100 - percent_up).toFixed(2)}%</span></p>
															</div>
															<div data-v-417299ea=""
																className="col-sm-6 col-md-6 pr-4 text-right"><p
																	data-v-417299ea=""><span data-v-417299ea=""
																		className="value colorGreen">{percent_up}%</span>
																	<span data-v-417299ea=""
																		className="name colorWhite">Mua</span></p></div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div> */}
								<div className="row">
									<div className='col-lg-6 col-12 mb-3 px-lg-auto px-3 trade-stat'>
										<div className='bo-stats border border-custom-border bg-secondarySidebar min-h-[292px] rounded-[22px]'>
											<div className='text-white text-lg mb-3 pt-3 pl-12 leading-[20px] font-bold text-left'>Trade Stats</div>
											<div className="d-flex flex-lg-row flex-column">
												<div className={`col-lg-6 col-12 mb-3 px-[15px] ${noData ? 'd-block' : 'd-none'} `}>
													<div className='d-flex justify-content-center align-items-center'>
														<div className='w-[151px] h-[151px] border-[15px] border-secondary-400 rounded-full d-flex flex-column justify-content-center align-items-center'>
															<div className='leading-[20px] mb-2 text-white'>{t('TradeTurns')}</div>
															<div className='text-xl font-weight-bold leading-[1] text-white'>{is_show_balance == 1 && !is_censored ? `${transaction_count}` : hide}</div>
														</div>
													</div>
												</div>
												<div className={`col-lg-6 col-12 mb-3 px-[15px] db-chart-container justify-content-center ${!noData ? 'd-flex' : 'd-none'} `}>
													<HighchartsReact
														ref={ref => this.refChart = ref}
														highcharts={Highcharts}
														options={options}
													/>
												</div>
												<div className='col-lg-6 col-12 md:py-4 px-[15px] mb-3 d-flex flex-column flex-lg-row align-items-center align-items-start align-middle'>
													<div className='d-flex flex-column justify-content-center'>
														<div className='d-flex align-items-center mb-3'>
															<span className='d-inline-block rounded-full bg-custom-win relative w-[20px] h-[20px] mr-[5px] overflow-hidden c-after'></span>
															<span className='text-base text-white'>{t('TotalRoundWin')}</span>
														</div>
														<div className='d-flex align-items-center mb-3'>
															<span className='d-inline-block rounded-full bg-custom-draw relative w-[20px] h-[20px] mr-[5px] overflow-hidden c-after'></span>
															<span className='text-base text-white'>{t('TotalRoundDraw')}</span>
														</div>
														<div className='d-flex align-items-center mb-3'>
															<span className='d-inline-block rounded-full bg-custom-lose relative w-[20px] h-[20px] mr-[5px] overflow-hidden c-after'></span>
															<span className='text-base text-white'>{t('TotalRoundLose')}</span>
														</div>
													</div>
												</div>
											</div>
											<div className='d-flex flex-lg-row flex-column'>
												<div className='col-lg-6 col-12 sm:mb-4 border-r border-r-light/[0.22] text-center'>
													<p className='mb-2 text-[#a0b1bc]'>{t('WinRate')}</p>
													<p className='text-xl leading-none font-weight-bold mb-3 text-white'>{this.getPercentWin()}</p>
												</div>
												<div className='col-lg-6 col-12 sm:mb-4 text-center'>
													<p className='mb-2 text-[#a0b1bc]'>{t('TotalTransaction')}</p>
													<p className='text-xl leading-none font-weight-bold mb-3 text-white'>{is_show_balance == 1 && !is_censored ? `$${fund}` : hide}</p>
												</div>
											</div>
										</div>
									</div>
									<div data-v-7a0c51c4="" className="col-12 px-lg-auto px-3 col-lg-6 mb-3">
										<div data-v-7a0c51c4="" className="row">
											<div data-v-7a0c51c4="" className="col-md-12 col-lg-6 mb-3" style={{ padding: isMobile() ? '0 1rem' : '' }}>
												<div data-v-7a0c51c4=""
													className="userStat profits py-lg-5 py-2rem d-flex align-middle justify-content-around">
													<div data-v-7a0c51c4="" className="wrap">
														<div data-v-7a0c51c4="" className="icon text-center">
															<svg data-v-7a0c51c4="" xmlns="http://www.w3.org/2000/svg"
																width="43.525" height="40.623"
																viewBox="0 0 43.525 40.623">
																<g data-v-7a0c51c4="" id="bar-graph-profit"
																	transform="translate(0 -1)">
																	<path data-v-7a0c51c4="" id="Path_29851"
																		data-name="Path 29851"
																		d="M42.074,38.722H40.623V2.451A1.451,1.451,0,0,0,39.173,1h-5.8a1.451,1.451,0,0,0-1.451,1.451V38.722h-5.8V14.058a1.451,1.451,0,0,0-1.451-1.451h-5.8a1.451,1.451,0,0,0-1.451,1.451V38.722h-5.8V25.664a1.451,1.451,0,0,0-1.451-1.451h-5.8A1.451,1.451,0,0,0,2.9,25.664V38.722H1.451a1.451,1.451,0,0,0,0,2.9H42.074a1.451,1.451,0,1,0,0-2.9Z"
																		fill="#b9c7ff" />
																</g>
															</svg>
														</div>
														<div data-v-7a0c51c4="" className="info">
															<p data-v-7a0c51c4="" className="name m-0 mb-2">{t('NetProfit')}</p>
															<p data-v-7a0c51c4="" className="value colorWhite m-0 d-flex">
																<span data-v-7a0c51c4="" className="font-arial"></span>
																<span data-v-7a0c51c4="">{is_show_balance == 1 && !is_censored ? `$${profit}` : hide}</span>
															</p>
														</div>
													</div>
												</div>
											</div>
											<div data-v-7a0c51c4="" className="col-md-12 col-lg-6 mb-3" style={{ padding: isMobile() ? '0 1rem' : '' }}>
												<div data-v-7a0c51c4=""
													className="userStat revenue py-lg-5 py-2rem d-flex align-middle justify-content-around">
													<div data-v-7a0c51c4="" className="wrap">
														<div data-v-7a0c51c4="" className="icon text-center">
															<svg data-v-7a0c51c4="" xmlns="http://www.w3.org/2000/svg"
																width="49.009" height="55.129"
																viewBox="0 0 49.009 55.129">
																<g data-v-7a0c51c4="" id="savings"
																	transform="translate(-4.441 -1)">
																	<path data-v-7a0c51c4="" id="Path_29852"
																		data-name="Path 29852"
																		d="M30.559,1A11.559,11.559,0,1,0,42.119,12.559,11.559,11.559,0,0,0,30.559,1Zm5.075,12.188-4.446,4.446a.889.889,0,0,1-1.257,0l-4.446-4.446a.889.889,0,0,1,0-1.257l4.446-4.446a.889.889,0,0,1,1.257,0l4.446,4.446A.889.889,0,0,1,35.634,13.188Z"
																		transform="translate(-1.613)"
																		fill="#bbe8e0" />
																	<path data-v-7a0c51c4="" id="Path_29853"
																		data-name="Path 29853"
																		d="M19.367,49l1.459,11.67a.889.889,0,0,0,.882.779H39.492a.889.889,0,0,0,.882-.779L41.833,49Z"
																		transform="translate(-1.654 -5.32)"
																		fill="#bbe8e0" />
																	<path data-v-7a0c51c4="" id="Path_29854"
																		data-name="Path 29854"
																		d="M53.149,32.773a15.086,15.086,0,0,0-23.314,4.239V28.95c-.3.019-.589.044-.889.044s-.594-.026-.889-.044v8.062A15.086,15.086,0,0,0,4.742,32.773a.889.889,0,0,0,0,1.334,15.056,15.056,0,0,0,19.339.513,13.3,13.3,0,0,1,3.93,8.6H18.276a.889.889,0,0,0-.882,1l.1.779H40.4l.1-.779a.889.889,0,0,0-.882-1H29.88a13.3,13.3,0,0,1,3.93-8.6,15.056,15.056,0,0,0,19.339-.513.889.889,0,0,0,0-1.334Z"
																		transform="translate(0 -3.098)"
																		fill="#bbe8e0" />
																</g>
															</svg>
														</div>
														<div data-v-7a0c51c4="" className="info">
															<p data-v-7a0c51c4="" className="name m-0 mb-2"> {t('TotalRevenue')}</p>
															<p data-v-7a0c51c4="" className="value colorWhite  m-0 d-flex">
																<span data-v-7a0c51c4="">{is_show_balance == 1 && !is_censored ? `$${revenue}` : hide}</span>
															</p>
														</div>
													</div>
												</div>
											</div>
											<div data-v-7a0c51c4="" className="col-md-12">
												<div data-v-417299ea="" data-v-7a0c51c4="" className="wrap-chart">
													<div data-v-417299ea="" className="chart-instance py-3">
														<div data-v-417299ea="" className="row">
															<div data-v-417299ea="" className="col-md-12 mb-2"><h4
																data-v-417299ea=""
																className="text-center font-20 color-white-50 mb-3">{t('TradeSumary')}</h4>
																<div data-v-417299ea="" className={setClassNameCondition(percent_up > -1, '', 'nodata', 'customChartPercent')}>
																	<div data-v-417299ea="" className="percentUp" style={{ width: percent_up > -1 ? `${percent_up}%` : '0%' }} />
																</div>
															</div>
															<div data-v-417299ea="" className="col-sm-6 col-md-6 pl-4">
																<p data-v-417299ea=""><span data-v-417299ea=""
																	className="name colorWhite">{t('Sell')}</span>
																	<span data-v-417299ea=""
																		className="value colorRed">{`${is_censored ? hide : (100 - percent_up).toFixed(2) + '%'}`}</span></p>
															</div>
															<div data-v-417299ea=""
																className="col-sm-6 col-md-6 pr-4 text-right"><p
																	data-v-417299ea=""><span data-v-417299ea=""
																		className="value colorGreen">{`${is_censored ? hide : percent_up + '%'}`}</span>
																	<span data-v-417299ea=""
																		className="name colorWhite">{t('Buy')}</span></p></div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							{!is_censored && <div data-v-7a0c51c4=""
								className="headerContent d-flex flex-lg-row flex-column justify-content-between align-items-center mb-3">
								<h1 data-v-7a0c51c4="" className="font-30 color-white font-weight-700 text-capitalize">{t('TransactionHistory')}</h1>
								<div data-v-7a0c51c4="" className="d-flex flex-lg-row flex-column pointer">
									<div className='d-flex mr-lg-4 position-relative border-b border-b-custom-border lg:min-w-[320px] align-items-center justify-content-center mb-3 mb-lg-0'>
										<div className='flex-1'>
											<DateRangePickerV2
												startDate={this.state.filter_from}
												endDate={this.state.filter_to}
												onDateChange={this.handleDateChange}
											/>
										</div>
									</div>
									{/* <DateRangePicker handleChangeDateRange={this.handleChangeDateRange} initStart={filter_from} initEnd={filter_to} /> */}
									<button onClick={this.loadTransaction} className="text-center button wbtn btn-large btn-radiant btn-border btn-radius px-3 py-2 color-white ml-2 h-auto" style={{ width: '145px' }}>{t("Search")}</button>
								</div>
							</div>}
							{!is_censored && <div className="position-relative">
								{isDesktop() && <div data-v-7a0c51c4="" className="table-responsive">
									<table className='br-0 table-bordered'>
										<thead>
											<tr>
												<th className='w-25'>OrderID</th>
												<th className='w-25'>{t('StartTime')}</th>
												<th className='w-15'>{t('Select')}</th>
												<th className='w-15'>{t('Selected')}</th>
												<th className='w-15'>{t('OpenPrice')}</th>
												<th className='w-15'>{t('ClosingPrice')}</th>
												<th className='w-15'>{t('Value')}</th>
												<th className='w-15'>{t('Pay')}</th>
											</tr>
										</thead>
										<tbody className='text-light'>
											{transaction_list.map((item, index) => (
												<tr className='font-weight-400' key={index}>
													<td className='font-weight-400'>{item.code}</td>
													<td className='font-weight-400'>{formatDate(item.created_at)}</td>
													<td className='font-weight-400'>{`${item.bet_condition === 'up' ? t('Buy') : t('Sell')}`}</td>
													<td className='font-weight-400'>
														<div className='d-flex justify-content-center align-items-center'>
															<span className={`icon ${item.bet_condition === 'up' ? 'up' : 'down'}`}></span>
															<span className='font-weight-bold'>{`${item.bet_condition === 'up' ? t('Buy') : t('Sell')}`}</span>
														</div>
													</td>
													<td>{is_show_balance == 1 ? item.open_price : hide}</td>
													<td>{is_show_balance == 1 ? item.close_price : hide}</td>
													<td>{is_show_balance == 1 ? formatNumber(item.bet_value) : hide}</td>
													<td className={`${item.value > 0 ? 'text-up' : ''}`}>{item.value > 0 ? `+${formatNumber(item.value + item.bet_value)}` : 0}</td>
												</tr>
											))}
										</tbody>
										<tfoot className='bt-1'>
											{transaction_list.length > 0 ? (
												<tr>
													<td colSpan={8}>
														<div className='d-flex w-100 justify-content-end'>
															<div className="d-flex justify-content-around w-10">
																<button disabled={page === 1}>
																	<svg className='pointer' onClick={this.handlePageChange('prev')}
																		xmlns="http://www.w3.org/2000/svg"
																		xmlSpace="preserve"
																		width={20}
																		height={20}
																		viewBox="0 0 55.753 55.753"
																		fill={page === 1 ? 'grey' : '#fff'}
																	>
																		<path d="M12.745 23.915c.283-.282.59-.52.913-.727L35.266 1.581a5.4 5.4 0 0 1 7.637 7.638L24.294 27.828l18.705 18.706a5.4 5.4 0 0 1-7.636 7.637L13.658 32.464a5.367 5.367 0 0 1-.913-.727 5.367 5.367 0 0 1-1.572-3.911 5.369 5.369 0 0 1 1.572-3.911z" />
																	</svg>
																</button>
																<span className='colorBlue4'>{page}</span>
																<button disabled={page === page_number.length}>
																	<svg className='pointer' onClick={this.handlePageChange('next')}
																		xmlns="http://www.w3.org/2000/svg"
																		xmlSpace="preserve"
																		width={20}
																		height={20}
																		fill={page === page_number.length ? 'grey' : '#fff'}
																		viewBox="0 0 55.752 55.752"
																	>
																		<path d="M43.006 23.916a5.36 5.36 0 0 0-.912-.727L20.485 1.581a5.4 5.4 0 0 0-7.637 7.638l18.611 18.609-18.705 18.707a5.398 5.398 0 1 0 7.634 7.635l21.706-21.703a5.35 5.35 0 0 0 .912-.727 5.373 5.373 0 0 0 1.574-3.912 5.363 5.363 0 0 0-1.574-3.912z" />
																	</svg>
																</button>
															</div>

														</div>
													</td>
													{/* <td colSpan={9}>
																	<ul id="page-numbers">
																		{page_number.map((number) => (
																			<li
																				key={number}
																				id={number}
																				onClick={this.handlePageChange(number)}
																				className={page === number ? 'active' : ''}
																			>
																				{number}
																			</li>
																		))}
																	</ul>
																</td> */}
												</tr>
											) : (
												<tr>
													<td colSpan={9}>{t('NoData')}</td>
												</tr>
											)}
										</tfoot>

									</table>
									{/* <DataTable
										columns={this.columns}
										data={transaction_list}
										pagination
										paginationServer
										paginationTotalRows={transaction_total}
										onChangeRowsPerPage={this.handlePerRowsChange}
										onChangePage={this.handlePageChange}
										sortServer
										onSort={this.onSort}
									/> */}
								</div>}
								{isMobile() && !is_censored &&
									<div>
										<ul>
											{transaction_list.map((item, index) => (
												<li className='bg-SecondarySidebar border border-custom-border rounded-13px py-25 px-ct-5 mb-18px' key={index}>
													<div className='d-flex justify-content-between align-items-center mb-18px'>
														<div className='font-weight-700 text-white'>BTC/USDT</div>
														<div className='text-text font-italic'>{formatDate(item.created_at)}</div>
													</div>
													<div className='d-flex justify-content-between align-items-center mb-18px'>
														<div className="d-block">
															<div className='text-text'>{t('YouChoose')}</div>
															<div className='d-flex gap-2 '>
																{item.bet_condition.toLocaleLowerCase() === 'down' && <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
																	<g id="Group_14968" data-name="Group 14968" transform="translate(0.128 2.723)">
																		<rect id="Rectangle_3774" data-name="Rectangle 3774" width="17" height="17" rx="2" transform="translate(-0.128 -2.723)" fill="#fc5f5f" />
																		<g id="triangle-head-arrow" transform="translate(7.038 0.217) rotate(45)">
																			<path id="Path_26245" data-name="Path 26245" d="M9.628,3.565,6.61,6.576a.3.3,0,0,1-.331.064.307.307,0,0,1-.189-.281l-.012-2.12L.312,4.207a.307.307,0,0,1-.305-.3L0,2.691a.3.3,0,0,1,.3-.3l5.767.032L6.057.3A.3.3,0,0,1,6.242.022.306.306,0,0,1,6.574.09L9.626,3.136a.306.306,0,0,1,.09.215A.3.3,0,0,1,9.628,3.565Z" transform="translate(0 0)" fill="#fff" />
																		</g>
																	</g>
																</svg>}
																{item.bet_condition.toLocaleLowerCase() === 'up' && <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
																	<g id="Group_13183" data-name="Group 13183" transform="translate(0.128 2.723)">
																		<rect id="Rectangle_3774" data-name="Rectangle 3774" width="17" height="17" rx="2" transform="translate(-0.128 -2.723)" fill="#1ebf75" />
																		<g id="triangle-head-arrow" transform="translate(2.325 7.087) rotate(-45)">
																			<path id="Path_26245" data-name="Path 26245" d="M9.628,3.565,6.61,6.576a.3.3,0,0,1-.331.064.307.307,0,0,1-.189-.281l-.012-2.12L.312,4.207a.307.307,0,0,1-.305-.3L0,2.691a.3.3,0,0,1,.3-.3l5.767.032L6.057.3A.3.3,0,0,1,6.242.022.306.306,0,0,1,6.574.09L9.626,3.136a.306.306,0,0,1,.09.215A.3.3,0,0,1,9.628,3.565Z" transform="translate(0 0)" fill="#fff" />
																		</g>
																	</g>
																</svg>
																}
																<span className='text-white'>{`${item.bet_condition.toLocaleLowerCase() === 'up' ? t('Buy') : t('Sell')}`}</span>
															</div>
														</div>
														<div>
															<button className='text-white border border-text rounded-5px d-inline-block leading-27px px-ct-5 py-1 bg-transparent'>{t('Copy')} OrderId</button>
														</div>

													</div>
													<div className='d-flex justify-content-between align-items-center mb-18px'>
														<div>
															<div className='text-text'>{t('OpenPrice')}</div>
															<div className='text-white'>{item.open_price}</div>
														</div>
														<div>
															<div className='text-text'>{t('ClosingPrice')}</div>
															<div className='text-white'>{item.close_price}</div>
														</div>
													</div>
													<div className='d-flex justify-content-between align-items-center mb-2.5'>
														<div>
															<div className='text-text'>{t('Value')}</div>
															<div className='text-white'>{item.bet_value}</div>
														</div>
														<div>
															<div className='text-text'>{t('Pay')}</div>
															<div className={`${item.value > 0 ? 'text-up' : ''}`}>{item.value > 0 ? `+${formatNumber(item.value)}` : 0}</div>
														</div>
													</div>
												</li>
											))}
											{transaction_list.length == 0 ? (<li className='bg-SecondarySidebar text-center py-3 border border-custom-border rounded-13px  px-ct-5 mb-18px pl-2'>
												<span className='text-white text-center'>{t('NoData')}</span>
											</li>) : (
												<div className='d-flex w-100 justify-content-center'>
													<div className="d-flex justify-content-around w-25">
														<button disabled={page === 1}>
															<svg className='pointer' onClick={this.handlePageChange('prev')}
																xmlns="http://www.w3.org/2000/svg"
																xmlSpace="preserve"
																width={20}
																height={20}
																viewBox="0 0 55.753 55.753"
																fill={page === 1 ? 'grey' : '#fff'}
															>
																<path d="M12.745 23.915c.283-.282.59-.52.913-.727L35.266 1.581a5.4 5.4 0 0 1 7.637 7.638L24.294 27.828l18.705 18.706a5.4 5.4 0 0 1-7.636 7.637L13.658 32.464a5.367 5.367 0 0 1-.913-.727 5.367 5.367 0 0 1-1.572-3.911 5.369 5.369 0 0 1 1.572-3.911z" />
															</svg>
														</button>
														<span className='colorBlue4'>{page}</span>
														<button disabled={page === page_number.length}>
															<svg className='pointer' onClick={this.handlePageChange('next')}
																xmlns="http://www.w3.org/2000/svg"
																xmlSpace="preserve"
																width={20}
																height={20}
																fill={page === page_number.length ? 'grey' : '#fff'}
																viewBox="0 0 55.752 55.752"
															>
																<path d="M43.006 23.916a5.36 5.36 0 0 0-.912-.727L20.485 1.581a5.4 5.4 0 0 0-7.637 7.638l18.611 18.609-18.705 18.707a5.398 5.398 0 1 0 7.634 7.635l21.706-21.703a5.35 5.35 0 0 0 .912-.727 5.373 5.373 0 0 0 1.574-3.912 5.363 5.363 0 0 0-1.574-3.912z" />
															</svg>
														</button>
													</div>
												</div>
											)}
										</ul>
									</div>}
							</div>}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		memberReducer: state.memberReducer,
		appReducer: state.appReducer
	};
}

export default connect(mapStateToProps, {
	fetchingUser,
	fetchingUserSuccess,
	updateMemberAction
})(withRouter(withTranslation()(Dashboard)));
